import React, {useEffect, useRef} from "react";
import css from "./product-xl-mouthpieces.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";
import type { IXLMouthpiece } from "./types";

interface ProductXLMouthpieceThumbnailsProps
{
    items: IXLMouthpiece[];
    handleSetMouthpieceThumbnail: (slug: string) => () => void;
    thumbnailsDirectory: string;
}

interface MouthpieceButtonProps
{
    category?: string;
    slug: string;
    handleSetMouthpieceThumbnail: (slug: string) => () => void;
    thumbnailsDirectory: string;
    title: string;
}

const MouthpieceButton = ({
    category, slug, handleSetMouthpieceThumbnail, thumbnailsDirectory, title
}: MouthpieceButtonProps) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [isSnaptixOpen, setIsSnaptixOpen] = React.useState<boolean>(false);

    useEffect(() => {
        const button = buttonRef.current;
        if (button) {
            button.addEventListener('click', handleSetMouthpieceThumbnail(slug));
            button.addEventListener('mouseenter', () => setIsSnaptixOpen(true));
            button.addEventListener('mouseleave', () => setIsSnaptixOpen(false));
            return () => {
                button.removeEventListener('click', handleSetMouthpieceThumbnail(slug));
                button.removeEventListener('mouseenter', () => setIsSnaptixOpen(true));
                button.removeEventListener('mouseleave', () => setIsSnaptixOpen(false));
            }
        }
    }, [handleSetMouthpieceThumbnail, slug]);

    return <button ref={buttonRef} data-category={category} key={slug} className='h-[168px] flex flex-col justify-end'>
        <VadImage
            src={slug.includes('snaptix')
                ? `${thumbnailsDirectory}${slug}-${isSnaptixOpen ? 'open' : 'closed'}.png`
                : `${thumbnailsDirectory}${slug}.png`
            }
            alt={title} width={45} height={120} key={`${slug}-image`} useOnlyOneDomain={true}/>
        <span>{title}</span>
    </button>
}

export const ProductXLMouthpieceThumbnails = ({ items, thumbnailsDirectory, handleSetMouthpieceThumbnail }: ProductXLMouthpieceThumbnailsProps): React.FunctionComponentElement<ProductXLMouthpieceThumbnailsProps> => 
{
    return (
        <nav className={css["thumbnails"]}>
            {
                items.map(({ category, slug, title }) => (
                    <MouthpieceButton key={slug} category={category} slug={slug} title={title} handleSetMouthpieceThumbnail={handleSetMouthpieceThumbnail} thumbnailsDirectory={thumbnailsDirectory} />
                ))
            }
        </nav>
    );
};